import { render } from "./RecaptchaV2Widget.vue?vue&type=template&id=27840e83&scoped=true&ts=true"
import script from "./RecaptchaV2Widget.vue?vue&type=script&lang=ts"
export * from "./RecaptchaV2Widget.vue?vue&type=script&lang=ts"

import "./RecaptchaV2Widget.vue?vue&type=style&index=0&id=27840e83&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27840e83"]])

export default __exports__